export default {
  message: 'Please check and make sure that all the annotations are finished'
}



// WEBPACK FOOTER //
// ./src/lang/en/task1005.js